import { createState } from '@hookstate/core';
import { formatEIN } from 'helpers/progressTracker';
import { Household } from 'models/household';
import UserData from 'models/UserData';

const OnboardingState = createState({
  //* step 1
  name: {
    first: '',
    middle: '',
    last: '',
    dob: '',
  },

  //* step 3
  businessAddress: {
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip: '',
  },
  mailingAddress: {
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip: '',
  },
  workPhone: '',
  physicalSameAsMailing: true,

  isSoleProp: null,

  entityType: '',

  //* step 2
  companyDetails: {
    suggested: [] as any,
    industry: '',
    description: '',
  },

  //* step 2
  existingCompanyDetails: {
    name: '',
    incorporationDate: '',
    ein: '',
    ssn: '',
    state: '',
  },

  //* step4
  bankDetails: {
    bankName: '',
    useOtherBank: false,
    useExistingBank: false,
  },

  //* step 5
  directDeposit: {
    bankName: '',
    routingNumber: '',
    bankAccountNumber: '',
    bankAccountType: '',
  },
});

export const userDataToOnboardingState = (
  household: Household | null,
  userData: UserData,
  isSolePropLocalStorage: boolean | null,
) => {
  const { userInfo, company } = userData;
  //* Set user info
  OnboardingState.name.set({
    first: userInfo.name?.first ?? '',
    middle: userInfo.name?.middle ?? '',
    last: userInfo.name?.last ?? '',
    dob: household?.head.dob ?? '',
  });

  //* Set user direct deposit details
  OnboardingState.directDeposit.set({
    bankName: userInfo.bankName ?? '',
    routingNumber: userInfo.routingNumber ?? '',
    bankAccountNumber: userInfo.bankAccountNumber ?? '',
    bankAccountType: userInfo.bankAccountType ?? '',
  });

  //* Set company details
  OnboardingState.isSoleProp.set(
    userData.isCompanySoleProp(isSolePropLocalStorage) as any,
  );

  OnboardingState.entityType.set(isSolePropLocalStorage as any);

  if (userData.isCompanySoleProp() === true) {
    OnboardingState.companyDetails.set({
      suggested: company?.suggested?.length ? company.suggested : [],
      industry: company?.industryCode ?? '',
      description: company?.description ?? '',
    });
  } else if (userData.isCompanySoleProp() === false) {
    OnboardingState.existingCompanyDetails.set({
      name: company?.name ?? '',
      incorporationDate: company?.incorporationDate ?? '',
      ein: company?.ein ? formatEIN(company?.ein) : '',
      ssn: '',
      state: company?.stateOfIncorporation ?? '',
    });
  }

  //* Set company bank details
  OnboardingState.bankDetails.set({
    bankName: company?.bankName ?? '',
    useExistingBank: company?.bankName ? !!company?.useExistingBank : false,
    useOtherBank: false,
  });

  //* Set Company contact details
  OnboardingState.businessAddress.set({
      street1: company?.businessAddress?.street1 ?? '',
      street2: company?.businessAddress?.street2 ?? '',
      city: company?.businessAddress?.city ?? '',
      state: company?.businessAddress?.state ?? '',
      zip: company?.businessAddress?.zip ?? '',
  });
  OnboardingState.mailingAddress.set({
      street1: company?.mailingAddress?.street1 ?? '',
      street2: company?.mailingAddress?.street2 ?? '',
      city: company?.mailingAddress?.city ?? '',
      state: company?.mailingAddress?.state ?? '',
      zip: company?.mailingAddress?.zip ?? '',
  });
  OnboardingState.workPhone.set(company?.workPhone ?? '');
  OnboardingState.physicalSameAsMailing.set(
    company?.businessAddress?.street1
      ? !!(
          company?.businessAddress?.street1 ===
            company?.mailingAddress?.street1 &&
          company?.businessAddress?.street2 ===
            company?.mailingAddress?.street2 &&
          company?.businessAddress?.city === company?.mailingAddress?.city &&
          company?.businessAddress?.state === company?.mailingAddress?.state &&
          company?.businessAddress?.zip === company?.mailingAddress?.zip
      )
    : true,
);
};

// eslint-disable-next-line import/no-default-export
export default OnboardingState;
